import { Component, Input } from '@angular/core';
import { PaginationObjectInterface } from '@components/components/pagination/pagination.component';
import { TableDataServiceObjectInterface, TableFilterInterface } from '@components/components/table/table.interface';

@Component({
  selector: 'sp-table-footer',
  standalone: false,
  templateUrl: './table-footer.component.html',
  styleUrls: ['./table-footer.component.scss']

})
export class TableFooterComponent implements TableFilterInterface {
  @Input() paginate = false;
  @Input() query = {};
  @Input() dateQuery = {};
  @Input() basicQuery = {};
  @Input() DataService: TableDataServiceObjectInterface = {
    create: () => {},
    update: () => {},
    fetch: () => {}
  };

  @Input() pagination: PaginationObjectInterface = {
    currentPage: 1,
    next: 2,
    prev: 0,
    last: 20,
    pageSize: 20,
    totalItems: 200
  };

  paginateIcons = {
    dropdown: '/public/resources/images/icons/icon-forward.svg',
    next: '/public/resources/images/icons/pagination-arrow-next.svg',
    prev: '/public/resources/images/icons/pagination-arrow-prev.svg'
  };

  fetch(direction = null, pageSize = null) {
    if (pageSize) {
      this.pagination.pageSize = pageSize;
    }

    if (direction) {
      switch (direction) {
        case 'next':
          if (this.pagination.currentPage < this.pagination.last) {
            this.pagination.currentPage++;
          }
          break;
        case 'previous':
          if (this.pagination.currentPage > 0) {
            this.pagination.currentPage--;
          }
          if (this.pagination.currentPage === 0) {
            this.pagination.currentPage = 1;
          }
          break;
      }
    } else {
      this.pagination.currentPage = 1;
    }

    const query = { ...this.basicQuery };

    Object.keys(this.basicQuery).forEach(key => {
      switch (typeof this.basicQuery[key]) {
        case 'string':
          query[key] = this.basicQuery[key];
          break;
        case 'object':
          query[key] = this.basicQuery[key].id;
          break;
      }
    });

    this.DataService.fetch(query, this.pagination);
  }
}